<template slot-scope="props">
  <div id="step-by-step" class="step-by-step-modal">
    <div class="wp-main-content">
      
      <form-wizard
        @on-change="tabChange"
        :start-index="0"
        shape="tab"
        color="#00a0e2"
        error-color="#ff4949"
        title=""
        subtitle=""
        ref="wizard"
      >
        <div class="top-gradient"></div>
        <tab-content title="">
          <div class="flow-start-container">
            <div class="flow-title__close first-tab-close">
              <img src="@/assets/img/icons/step-by-step-close.svg" @click="closeStepByStep" />
            </div>
            <div class="flow-start__left">
              <img src="@/assets/img/link_img/mehmet-kirci-start.jpg" />
            <span class="mobile-start-button" @click="startTest">Teste başla</span>
            </div>
            <div class="flow-start__right">
              <span class="flow-start__title">Artık sudan geçirmek için mazeretimiz yok!</span>
              <p class="flow-start__description">
                Testi çözün, uzmanından ipuçları alın,<br> bulaşıkları bir daha sudan geçirmenize<br> gerek kalmasın.
              </p>
              
              <div class="flow-start__button">
                <span @click="startTest">Teste başla</span>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="">
          <div class="flow-container">
          <div class="flow-title__close first-tab-close">
              <img src="@/assets/img/icons/step-by-step-close.svg" @click="closeStepByStep" />
            </div>
            <div class="flow-title">
              <div class="flow-title__icon">
                <img src="@/assets/img/icons/shape-3-title.svg">
              </div>
              <span>4 Soruda Sudan Geçirmeden Mükemmel Temizlik Testi</span>
            </div>
            <span class="flow-status__title">SORULAR</span>
            <div class="flow-question-container">
              <div class="flow-question-item scroll-query query-1" data-anchor="question1">
                <span class="flow-question__title">1. Sizce bu makine temiz mi?</span>
                <div class="flow-question__image">
                  <img src="@/assets/img/link_img/720x900-soru-1.jpg">
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q1yes" name="question1" data-anchorLink="query-2" data-anchor="question2" value="true" @click="selectedOption">
                  <label for="q1yes">EVET</label>
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q1no" name="question1" data-anchorLink="query-2" data-anchor="question2" value="false" @click="selectedOption">
                  <label for="q1no">HAYIR</label>
                </div>
              </div>
              <div class="flow-question-item scroll-query query-2" data-anchor="question2">
                <span class="flow-question__title">2. Siz de bulaşıkları bu şekilde mi yerleştiriyorsunuz?</span>
                <div class="flow-question__image">
                  <img src="@/assets/img/link_img/720x900-soru-2.jpg">
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q2yes" name="question2" data-anchorLink="query-3" data-anchor="question3" value="true" @click="selectedOption">
                  <label for="q2yes">EVET</label>
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q2no" name="question2" data-anchorLink="query-3" data-anchor="question3" value="false" @click="selectedOption">
                  <label for="q2no">HAYIR</label>
                </div>
              </div>
              <div class="flow-question-item scroll-query query-3" data-anchor="question3">
                <span class="flow-question__title">3. Suyunuzdaki kireç seviyesini biliyor musunuz?</span>
                <div class="flow-question__image">
                  <img src="@/assets/img/link_img/720x900-soru-3.jpg">
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q3yes" name="question3" data-anchorLink="query-4" data-anchor="question4" value="true" @click="selectedOption">
                  <label for="q3yes">EVET</label>
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q3no" name="question3" data-anchorLink="query-4" data-anchor="question4" value="false" @click="selectedOption">
                  <label for="q3no">HAYIR</label>
                </div>
              </div>
              <div class="flow-question-item scroll-query query-4" data-anchor="question4">
                <span class="flow-question__title">4. Bulaşıkta yüksek performanslı bir deterjan mı tercih ediyorsunuz?</span>
                <div class="flow-question__image">
                  <img src="@/assets/img/link_img/720x900-soru-4.jpg">
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q4yes" name="question4" value="true" data-anchor="question4" @click="selectedOption">
                  <label for="q4yes">EVET</label>
                </div>
                <div class="flow-question__option">
                  <input type="radio" id="q4no" name="question4" value="false" data-anchor="question4" @click="selectedOption">
                  <label for="q4no">HAYIR</label>
                </div>
              </div>
            </div>
            <div class="answers-container" v-show="answerContainer">
            <div class="answer-image">
              <img src="@/assets/img/link_img/mehmet-kirci-tick.png">
            </div>
            
            
            <span class="flow-status__title">CEVAPLAR</span>
            <div class="flow-question-container">
              <div class="flow-question-item">
                <span class="flow-question__title flow-answer__title">1. MAKİNENİZ TEMİZ GÖRÜNSE DE TEMİZ OLMAYABİLİR</span>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Makinenizin gözle göremediğiniz yerlerinde kireç, yağ ve kir birikiyor.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Bunlar makineyi tıkar, bu yüzden bulaşıklarınız kirli çıkar.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Temiz makine, temiz bulaşıklar için 3 ayda bir Finish Makine Temizleyici kullanın.</span>
                </div>
                <div class="flow-answer__image">
                  <img src="@/assets/img/link_img/finish-1.png">
                </div>
              </div>
              <div class="flow-question-item">
                <span class="flow-question__title flow-answer__title">2. DOĞRU YERLEŞİMLE BULAŞIKLAR DAHA İYİ YIKANIR</span>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Bulaşıklarınızı yanlış dizerseniz, bulaşıklar tam temizlenmez.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Çatal, kaşık, bıçakları zıt yönlerde yerleştirin.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Boyutu büyük bulaşıklarda, lekeli yüzleri aşağıdaki pervaneye dönük olacak şekilde alt rafa yerleştirin.</span>
                </div>
              </div>
              <div class="flow-question-item">
                <span class="flow-question__title flow-answer__title">3. SUDAKİ KİREÇ BİRÇOK LEKENİN KAYNAĞI OLABİLİR</span>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Ülkemizin suları kireçli. Suların %17’si orta sertlikte kireçli, %50’si yüksek sertlikte kireçli ve %25’i ise çok yüksek sertlikte kireçli.</span>
                </div>
                <div class="flow-answer__image">
                  <img src="@/assets/img/link_img/answer3.png">
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Kireç yüzünden bulaşıklarınız yeterince temiz ve parlak olmaz.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Kirecin önüne geçmek için Finish Özel Tuz kullanın.</span>
                </div>
              </div>
              <div class="flow-question-item">
                <span class="flow-question__title flow-answer__title answer-big-title"><span>4.</span> YENİ FINISH QUANTUM <i class="quantum-ultimate">ULTIMATE</i> ve QUANTUM MAX <i>ACTIVBLU</i> İLE KURUMUŞ LEKELER BİLE ÇIKAR!</span>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                  </div>
                <span class="flow-answer__content answer-big-subtitle">Yeni Finish Quantum Ultimate:</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Cam Aşınma Karşıtı Sistemiyle makinede yıkamaya kıyamadığınız hassas cam bulaşıklarınızı güvenle makinede yıkamanızı sağlar.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Cam bulaşıklarınızın ömrünü uzatır.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Saatlerce kurumuş lekeleri bile sudan geçirmeden çıkarır.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Her yıkamada 57 litre su tasarrufu sağlar.</span>
                </div>
                <div class="flow-answer__image">
                  <img src="@/assets/img/link_img/ultimate1.png">
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                  </div>
                <span class="flow-answer__content answer-big-subtitle">Yeni Finish Quantum ActivBlu:</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">İçerisindeki güçlü mavi parçacıklar sayesinde, saatlerce beklemiş lekeleri bile sudan geçirmeden çıkarır.</span>
                </div>
                <div class="flow-answer__option-item">
                  <div class="flow-answer__right-icon">
                    <img src="@/assets/img/icons/right-arrow.svg">
                  </div>
                  <span class="flow-answer__content">Her yıkamada 57 litre su tasarruf edersiniz.</span>
                </div>
                <div class="flow-answer__image">
                  <img src="@/assets/img/link_img/quantum1.png">
                </div>
              </div>
            </div>
          </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import EventBus from "../main";
import store from "../store";
import carousel from "vue-owl-carousel";
import axios from "axios";
export default {
  data() {
    return {
      answerContainer: false,
      answersArray: [],
      numberMask: false,
      warningMessages: false,
      hostname:'',
      votedAutoNext: '',
      access_token: "",
      access_tokenRB: "",
      selectedVote: false,
      serviceVote: [],
      vote: [
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
        { yes: 0, no: 0, option: null },
      ],
      unmute: true,
      test: "",
      videoIsFinished: false,
      value: "",
      answers: [],
      resultList: [{staus:false},{status:false},{status:false},{status:false},{status:false},{status:false}],
      selectedResultListDup: [{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''},{0:'',1:'',2:'',3:''}],
      activeTab: 0,
      isQuestionTabs: [2, 3, 4, 5],
      formData: {
        name: "",
        email: "",
        phone: "",
        city: "",
        brand: "",
        callTime: "",
        kvkk: false,
        IsNotification: false,
        IsClarification: false,
        personalData: false
      },
      sonuc: {
        /*2: {
          question: "SORU 1",
          true: {
            option: true,
            title: "MAKİNENİZİN BAKIMINA ÖZEN GÖSTERMEYİ UNUTMAYIN!",
            content:
              'Makine yaşınız 5’ten büyük olduğu için bakımına daha da özen göstermeniz gerekmektedir. Düzenli bakım yani makine temizliği sayesinde makinenizden daha iyi performans alırsınız, makinenizin ömrü uzar ve bulaşıklarınız da daha temiz olur. <br><br> <i><b>Makinenizin bakımı için:</b></i> <br> <ul><li>Bulaşıklarınızı fırça ve peçeteyle çöpe sıyırıp makineye yerleştirin.</li><li>Makinenizi temizlemek için sirke, çamaşır suyu ve karbonat gibi maddeler kullanmayın. Çünkü bunlar makinenizin parçalarına zarar verir.</li><li>Makinenizi 3 ayda bir Finish Makine Temizleyici ile temizleyin.</li></ul><a href="https://www.hepsiburada.com/ara?q=finish+bula%C5%9F%C4%B1k+makinesi+temizleyici" target="_blank">Makine Temizleyici satın al</a> ',
          },
          false: {
            option: false,
            title: "DÜZENLİ BAKIMLA MAKİNENİZİN PERFORMANSINI ARTIRIN!",
            content:
              'Makinenizin yaşı 5’ten küçük olsa da makinenizi düzenli aralıklarla temizlemeyi unutmayın. Böylece, makinenizin performansı artar, ömrü uzar ve bulaşıklarınız da daha temiz olur. <br><br> <i><b>Makinenizin bakımı için:</b></i> <br> <ul><li>Bulaşıklarınızı fırça ve peçeteyle çöpe sıyırıp makineye yerleştirin.</li><li>Makinenizi temizlemek için sirke, çamaşır suyu ve karbonat gibi maddeler kullanmayın. Çünkü bunlar makinenizin parçalarına zarar verir.</li><li>Makinenizi 3 ayda bir Finish Makine Temizleyici ile temizleyin.</li></ul><a href="https://www.hepsiburada.com/ara?q=finish+bula%C5%9F%C4%B1k+makinesi+temizleyici" target="_blank">Makine Temizleyici satın al</a>',
          },
        },*/
        2: {
          question: "SORU 2",
          true: {
            option: true,
            title: "SİZ GÖRMESENİZ DE MAKİNENİZ KİRLİ OLABİLİR.",
            content:
              'Makinenizin içi temiz görünse de gözle görülemeyen yerlerinde kireç, yağ ve kir birikir. Bu da performansı olumsuz etkiler. Finish Makine Temizleyici ile makinenizi 3 ayda bir temizlediğinizde hem makinenizden tam performans alırsınız hem de bulaşıklarınız tertemiz olur. <br><br> <a href="https://www.hepsiburada.com/ara?q=finish+bula%C5%9F%C4%B1k+makinesi+temizleyici" target="_blank">Makine Temizleyici satın al</a>',
          },
          false: {
            option: false,
            title:
              "TEBRİKLER, MAKİNE TEMİZLİĞİNDE GÖZLE GÖRÜLMEYEN YERLERİN FARKINDASINIZ.",
            content:
              'Makinenizi 3 ayda bir Finish Makine Temizleyici ile temizleyerek, gözle görülmeyen yerlerdeki yağ, kireç ve kiri yok edebilirsiniz. Böylece makinenizin performansı artar, bulaşıkları sudan geçirmenize de gerek kalmaz. <br><br> <a href="https://www.hepsiburada.com/ara?q=finish+bula%C5%9F%C4%B1k+makinesi+temizleyici" target="_blank">Makine Temizleyici satın al</a>',
          },
        },
        3: {
          question: "SORU 3",
          true: {
            option: true,
            title:
              "BULAŞIKLARI DOĞRU YERLEŞTİREREK DAHA TEMİZ OLMASINI SAĞLAYABİLİRSİNİZ.",
            content:
              "Bulaşıkları doğru yerleştirirseniz hem sudan geçirmeye ihtiyacınız kalmaz hem de bulaşıklarınız çok daha temiz olur. <br><br> <i><b>Bulaşıklarınız makineye doğru yerleşimi için: </b></i> <br> <ul><li>Makinenizi tıka basa doldurmayın, bulaşıklarınız nefes alsın.</li><li>Tabakları alt rafa, büyükten küçüğe arkadan öne doğru dik bir şekilde dizin.</li><li>Çatal, kaşık ve bıçakların iç içe geçmemesine özen gösterin.</li><li>Tencere, tava, borcam gibi boyutu büyük bulaşıkların makinede yıkanabilen özellikte olduklarından emin olun. Lekeli yüzleri aşağıdaki pervaneye dönük olacak şekilde alt rafa yerleştirin.</li></ul>",
          },
          false: {
            option: false,
            title: "TEBRİKLER, BULAŞIKLARI DOĞRU YERLEŞTİRİYORSUNUZ.",
            content:
              "Bulaşıkları doğru yerleştirdiğiniz için bulaşıklarınız sudan geçirmeden tertemiz oluyor. Böylece her yıkamada 57 litre suyu tasarruf ediyorsunuz. <br><br> <i><b>Yine de unutmamakta fayda var: </b></i> <br> <ul><li>Makinenizi tıka basa doldurmayın, bulaşıklarınız nefes alsın.</li><li>Tabakları alt rafa, büyükten küçüğe arkadan öne doğru dik bir şekilde dizin.</li><li>Çatal, kaşık ve bıçakların iç içe geçmemesine özen gösterin.</li><li>Tencere, tava, borcam gibi boyutu büyük bulaşıkların makinede yıkanabilen özellikte olduklarından emin olun. Lekeli yüzleri aşağıdaki pervaneye dönük olacak şekilde alt rafa yerleştirin.</li></ul>",
          },
        },
        4: {
          question: "SORU 4",
          true: {
            option: true,
            title: "MAALESEF SUYUMUZ KİREÇLİ!",
            content:
              'Türkiye’nin hangi bölgesinde olursak olalım sularımız kireçli. Makinenizin zarar görmemesi ve maksimum performans sağlaması için Finish Özel Tuz kullanabilirsiniz. <br><br> <a href="https://www.hepsiburada.com/ara?q=finish+tuz&filtreler=MainCategory.Id:80366066" target="_blank">Finish Özel Tuz satın al</a><br><h3>TÜRKİYE\'DEKİ SULARIN SERTLİK ORANI</h3><div style="width:100%"><img style="width:100%" src="/img/finish_teknisyen_kirec_pie_chart.d3a80c9b.jpg"></div>',
          },
          false: {
            option: false,
            title: "MAALESEF SUYUMUZ KİREÇLİ!",
            content:
              'Aşağıdaki grafikten ülkemizdeki suların sertlik durumunu görebilirsiniz. Makinenizin ömrünü uzatmak ve makinenizden daha iyi performans almak için Finish Özel Tuz kullanabilirsiniz. <br><br> <a href="https://www.hepsiburada.com/ara?q=finish+tuz&filtreler=MainCategory.Id:80366066" target="_blank">Finish Özel Tuz satın al</a><br><h3>TÜRKİYE\'DEKİ SULARIN SERTLİK ORANI</h3><div style="width:100%;"><img style="width:100%" src="/img/finish_teknisyen_kirec_pie_chart.d3a80c9b.jpg"></div>',
          },
        },
        5: {
          question: "SORU 5",
          true: {
            option: true,
            title:
              "TEBRİKLER, GÜÇLÜ VE PERFORMANSI YÜKSEK BİR DETERJAN TERCİH EDİYORSUNUZ.",
            content:
              "Finish Quantum Max, daha az kimyasalla maksimum performans sunar. ActivBlu teknolojisi sayesinde de bulaşıklarınız sudan geçirmeden tertemiz olur. Böylece, her yıkamada 57 litre su tasarruf edersiniz.",
          },
          false: {
            option: false,
            title:
              "MÜKEMMEL TEMİZLİK VE PARLAKLIK İÇİN QUANTUM MAX’I TERCİH EDİN!",
            content:
              'Bulaşıklarınızı Finish Quantum Max ile yıkadığınızda mükemmel temizlik ve parlaklık elde edersiniz. Çünkü Quantum Max güçlü mavi parçacıklara sahip ActivBlu teknolojisiyle kurumuş lekeleri bile sudan geçirmenize gerek kalmadan çıkarır. <br><br> <a href="https://www.trendyol.com/sr?q=Finish%20Quantum%20Max&qt=Finish%20Quantum%20Max&st=Finish%20Quantum%20Max&os=1" target="_blank">Finish Quantum MAX satın al</a>',
          },
        },
      },

      model: {
        firstName: "",
        lastName: "",
        email: "",
        streetName: "",
        streetNumber: "",
        city: "",
        country: "",
      },
      test: true,
      name: "",
      tabs: "",

      totalTabs: "",
      isActive: false,
    };
  },
  components: { carousel },
  methods: {},
  
  mounted() {
    //window.addEventListener("scroll", function(){
      var sections = $('.scroll-query');
      
        
            //nav = $('nav.storeNav')
            //header_height = $("header").outerHeight();
            
  
      /*  $(".flow-container").on('scroll', function() {
          var cur_pos = $(this).scrollTop();
         // console.log('CURRENT POS : ',cur_pos);          
            
            sections.each(function(index) {
                  var top = $(this).offset().top,
                      bottom = top + $(this).outerHeight();
                  switch (index) {
                    case 0:
                      top+= 0;
                      bottom += 800;
                      break;
                    case 1:
                      top+= 800;
                      bottom += 1200;
                      break;
                    case 2:
                       top+= 1600;
                       bottom += 2250;
                       break;
                    case 3:
                      top += 2250;
                      bottom += 2000;
                      break;
                    default:
                      break;

                  }
                  
                  
           //       console.log(index, 'ITEM TOP : ',top);
           //       console.log(index, "ITEM BOTTOM : ", bottom);
              if (cur_pos >= top && cur_pos <= bottom) {
                  //console.log($(this).attr("data-anchor"))
                  if(typeof $(this).attr("data-anchor") != "undefined") {
                    var searchParams = new URLSearchParams(window.location.search)
                    searchParams.set("site", $(this).attr("data-anchor"));
                    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                    history.pushState(null, '', newRelativePathQuery);
                  }
                  //$(this).addClass('active');
                  //nav.find('a[data-anchor="' + $(this).attr('data-anchor') + '"]').addClass('active');
              }
            });
        });*/
    //})
    

    this.tabChange();
    this.totalTabs = this.tabs.length;
    if(window.location.pathname == '/sudan-gecirmeden-temizle'){
      $('.navigation-main a.router-link-active.home-screen').removeClass('home-screen');
    }
    $('.item-form-wrapper input, .item-form-wrapper select').focus(function(e){
		$(e.target).addClass('focus');
    });
      $('.item-form-wrapper input, .item-form-wrapper input').blur(function(e){
      if(!e.target.value.length) {
        $(e.target).removeClass('focus');		
      }
    });
    if(window.screen.width < 1024) {
      let deviceHeight = (window.screen.height / 100);
      let deviceWidth = (window.screen.width / deviceHeight);
      if(deviceWidth <= 50) {
        $('.background-image video').addClass('horizontal');
      }
    }
    
  },

  props: {},
  methods: {
    selectedOption(event) {
      
      let answerIndex = event.currentTarget.name.split("question")[1];
      this.answersArray[answerIndex - 1] = event.currentTarget.value;

      let dataLayerQuestion = 'technician_Question'+answerIndex;
      dataLayer.push({'event': dataLayerQuestion, 'answer': event.currentTarget.value})


      $(event.currentTarget).closest(".flow-question-item").find(".flow-question__option").removeClass("option-active");
      $(event.currentTarget).closest(".flow-question__option").addClass("option-active");
      
      if(this.answersArray.length == 4 && !this.answersArray.includes(undefined)) {
        $(".flow-question-container").css("margin-bottom","50px");
        this.answerContainer = true;
        $(".answer-container").show();
        setTimeout(() => {
          $('.flow-container').animate({
          scrollTop: $(".answers-container").offset().top + $(".flow-container").scrollTop() - 20 - $(document).scrollTop()
        }, 500);
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set("site", "answers");
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        return false;
        }, 300);
        this.answersArray.forEach((item,index) => {
          
            var data = {
              Index: index + 1,
              QuestionYes: item == "true" ? true : false,
              QuestionNo: item == "false" ? false : true,
            };
            
          
          /*axios.post(this.hostname+'/api/TechnicianSupportJourney/Add', data,{
          headers: {
            "Authorization":"Bearer " + this.access_token
          }
        })*/
        })
        
      } else {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set("site", $(event.currentTarget).attr("data-anchor"));
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        $('.flow-container').animate({
            scrollTop: $("."+ $(event.currentTarget).attr("data-anchorLink") ).offset().top + $(".flow-container").scrollTop() - 20 - $(document).scrollTop()
          }, 500);
          return false;
        }
      
        
     // }
     
    },
    
    startTest() {
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.set("site", "teste-basla");
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
      dataLayer.push({'event':'technician_startQuiz'})
      this.hostname = window.location.origin;
      this.$refs.wizard.nextTab();
      //this.videoUnmute();
      //this.$refs.wizard.nextTab();
      const params = new URLSearchParams();
      params.append("username", "apiuser@yarininsuyu.com");
      params.append("password", "VAv3dNfmyogCXxw9Fdi8vUBHuiqT24NVVxp0jmlvV2o=");
      params.append("grant_type", "password");
      axios.post(this.hostname+"/oauth/token", params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          this.access_token = response.data.access_token;
        });
        setTimeout(() => {
        $('.flow-container').animate({
          scrollTop: $(".query-1").offset().top + $(".flow-container").scrollTop() - 20 - $(document).scrollTop()
        }, 500);
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set("site", "question1");
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        return false;
        }, 300);
        
    },
    videoUnmute() {
      this.unmute = false;
      var arrayVideo = document.getElementsByTagName("video");
      arrayVideo.forEach((item) => {
        item.removeAttribute("muted");
        item.muted = false;
      });
    },
    getTokenRB() {
      var datas = this.formData;

      if (datas.brand != "" && datas.callTime != "" && datas.city != "" && datas.email != "" && datas.email.indexOf('@') != -1 != "" && datas.name != "" && datas.phone.length == 14 && datas.IsClarification != false && datas.personalData != false) {
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.set("site", "tesekkurler");
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
      var $this = this;
      $(".result-item-form").fadeOut();
      $(".result-form-left").css("display","flex").css("align-items","center").css("justify-content","center");
      $('.result-item-form__input-button').hide();
      $(".result-item-form__loading").show();
      var config = {
      method: 'post',
      url: this.hostname+'/api/Ouath2?client_id=67b1b71a6b5f48a59a5cb595d05a6c13&client_secret=39c5F54816314fd7A301a589B1A8DBC3&grant_type=client_credentials',
      headers: { 'Authorization': `Bearer ${$this.access_token}` }
      };
      axios(config)
      .then(function (response) {
        $this.access_tokenRB = response.data.model.access_token;
        var date = new Date();
        var serviceData = {
        "AccessToken": response.data.model.access_token,
        "FirstName": datas.name,
        "LastName": datas.name,
        "Email": datas.email,
        "Phone": datas.phone.replaceAll('(','').replaceAll(')','').replaceAll(' ','').replaceAll('-',''),
        "City": datas.city,
        "MachineBrand": datas.brand,
        "TimePeriod": datas.callTime,
        "IsKVKK": datas.kvkk,
        "IsNotification": datas.IsNotification,
        "IsClarification": datas.IsClarification,
        "Question1Answer": false,
        "Question2Answer": JSON.parse($this.answersArray[0]),
        "Question3Answer": JSON.parse($this.answersArray[1]),
        "Question4Answer": JSON.parse($this.answersArray[2]),
        "Question5Answer": JSON.parse($this.answersArray[3])
    }
    
      axios.post($this.hostname+"/api/PartnerBundle/Lead", JSON.stringify(serviceData),{headers : {
            'Authorization': `Bearer ${$this.access_token}`,
            'Content-Type':'application/json' 
            }})
            .then((response) => {
              if(response.data.status == "success") {
                $(".result-item-form__loading").hide();
                $(".result-item-form__success").fadeIn();
                dataLayer.push({'event':'technician_sendForm'});
                $this.warningMessages = true;
                $this.formData.name = "",
                $this.formData.phone = "",
                $this.formData.email = "",
                $this.formData.brand = "",
                $this.formData.callTime = "",
                $this.formData.kvkk = false;
                $this.formData.IsNotification = false;
                $this.formData.IsClarification = false;
                $this.formData.personalData = false;
                $this.formData.city = "";
                let searchParams = new URLSearchParams(window.location.search)
                searchParams.set("site", "tesekkurler");
                let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                history.pushState(null, '', newRelativePathQuery);
              }
          })
          .catch((error) => {
            $(".result-item-form__loading").hide();
            $(".result-item-form__error").fadeIn();
            $this.warningMessages = true;
            let searchParams = new URLSearchParams(window.location.search)
            searchParams.set("site", "tesekkurler");
            let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
          });
        }).catch(error => {
          $(".result-item-form__loading").hide();
          $(".result-item-form__error").fadeIn();
          $this.warningMessages = true;
        })
       }
    },
    acceptNumber() {
     if(this.formData.phone.length == 1 && this.formData.phone == '0') {
        this.formData.phone = '';
        return false;
      } else if(this.formData.phone.length >= 1 ){
        this.numberMask = true;
        var x = this.formData.phone.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.formData.phone = !x[2] ? x[1] :  "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      }
    },
    zeroHideFocus() {
      this.numberMask = true;
    },
    zeroHideBlur() {
      if(this.formData.phone.length >= 1) {
        this.numberMask = true;
      }else {
        this.numberMask = false;
      }
    },
    closeStepByStep() {
      if(window.location.pathname == '/sudan-gecirmeden-temizle') {
        $('#home-container').show();
        this.$router.push({name: "Home"})
        EventBus.$emit("step-by-step-status");
      } else {
        this.activeTab = 0;
        EventBus.$emit("step-by-step-status");
      }
      this.$refs.wizard.reset();
      window.history.replaceState(null, null, window.location.pathname);
    },
    backTab() {
      if(this.activeTab != 1) {
        this.$refs.wizard.prevTab();
      }
      if (typeof this.answers[this.activeTab] != "null") {
        this.videoIsFinished = true; 
      }
    },
    watchAgain() {
      var thisTabVideo = document.querySelectorAll(".wizard-tab-container video")[this.activeTab - 1];
      thisTabVideo.currentTime  = 0;
      thisTabVideo.play();
      this.votedAutoNext = false;
      this.videoIsFinished = false;
    },
    controlAnswer() {
      if (typeof this.answers[this.activeTab] != "undefined") {
        this.$refs.wizard.nextTab();
      }
    },
    answerMethod(event) {
      
      let $this = this;
      var selectedValue = event.currentTarget.dataset.value;
      this.answers[this.activeTab] = [
        this.activeTab,
        event.currentTarget.dataset.value,
        this.sonuc[this.activeTab]["question"],
        this.sonuc[this.activeTab][selectedValue].title,
        this.sonuc[this.activeTab][selectedValue].content,
      ];
      if (!this.selectedVote){
        this.selectedResultListDup[this.activeTab] = [
          this.activeTab,
          event.currentTarget.dataset.value,
          this.sonuc[this.activeTab]["question"],
          this.sonuc[this.activeTab][selectedValue].title,
          this.sonuc[this.activeTab][selectedValue].content,
        ];
      }
      var data = {
        Index: this.isQuestionTabs.indexOf(this.activeTab) + 2,
        QuestionYes: selectedValue == "true" ? true : false,
        QuestionNo: selectedValue == "true" ? false : true,
      };

      if (typeof this.answers[this.activeTab] != undefined && this.selectedVote == false) {
        axios.post(this.hostname+'/api/TechnicianSupportJourney/Add', data,{
          headers: {
            "Authorization":"Bearer " + this.access_token
          }
        })
        .then((response) => {
          if(!this.selectedVote) {            
            //let dataLayerQuestion = 'Question'+($this.isQuestionTabs.indexOf($this.activeTab)+2);
            //let exampledatalayer = {'event': dataLayerQuestion,'answer': selectedValue};
            
            //dataLayer.push({'event': dataLayerQuestion,'answer': selectedValue});
            
            this.vote[this.activeTab].yes = response.data.model.yesRate;
            this.vote[this.activeTab].no = response.data.model.noRate;
            this.vote[this.activeTab].option = JSON.parse(selectedValue);
            this.selectedVote = true;
            this.votedAutoNext = true;
            $('.yes-vote-rate').parent('.vote-item').css('width',this.vote[this.activeTab].yes+'%');
            $('.no-vote-rate').parent('.vote-item').css('width',this.vote[this.activeTab].no+'%');
            if(this.vote[this.activeTab].no < 30) {
              $('.no-vote-rate').parent('.vote-item').css('width','30%');
              $('.yes-vote-rate').parent('.vote-item').css('width','70%');
            }
            if(this.vote[this.activeTab].yes < 30) {
              $('.no-vote-rate').parent('.vote-item').css('width','30%');
              $('.yes-vote-rate').parent('.vote-item').css('width','70%');
              $('.yes-vote-rate').parent('.vote-item').find('span:last-child').addClass('fs--07vw');
            }
            setTimeout(() => {
              if(this.votedAutoNext){
                this.$refs.wizard.nextTab();
              }
            }, 3000);
          }
        }, (error) => {
          
        });
      }
    },
    accordionItem(event) {
      $(event.currentTarget.parentElement)
        .find(".result-item__content p")
        .slideToggle("slow");
      $(event.currentTarget.parentElement).toggleClass("result-active-tab");
    },

    tabChange: function (prev = 0, next = 0) {
      
      this.activeTab = next;
      if (next == 1 || next == 0 ) {
        $(".top-gradient, .vue-form-wizard .wizard-nav-pills").hide();
        $(".vue-form-wizard .wizard-card-footer").css("display", "none");
      } else {
        $(".top-gradient, .vue-form-wizard .wizard-nav-pills").show();
        $(".vue-form-wizard .wizard-card-footer").css("display", "flex");
      }
    },
  },

  watch: {
    currentTab() {
      store.setCurrentTab(this.currentTab);
    },
  },
  created() {
    this.isActive = this.selected;
    
    
  },
};
</script>

<style lang="scss">
.flow-answer__content.answer-big-subtitle {
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 1.3vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.5vw !important;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    font-size: 3.5vw !important;
   }
}
.answer-big-title i.quantum-ultimate {
  color: #cfb983;
}
.answer-content {
  width: 100%;
  background-color: #49a5df;
  display: flex;
  justify-content: center;
  padding: 30px 80px;
  background-repeat: no-repeat;
  background-position: top 10px left -30%;
  background-image: url('../../src/assets/img/icons/information-icon.png');
  @media only screen and (max-device-width: 768px) {
     background-position: top 30px left -10%;
     
  }
}
.answer-content span{
  font-size: 2.9476vw;
  font-weight: bold;
  color: white; 
  text-align: center;
  @media only screen and (max-device-width: 768px) {
    font-size: 6.4062vw; 
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    font-size: 5.3476vw;
  }
  @media only screen and (min-device-width: 1025px) and (max-device-width: 1450px) {
    font-size: 4.0476vw;
  }
  @media only screen and (min-device-width: 1025px) and (max-device-width: 1450px) {
    font-size: 4.0476vw;
  }
  @media only screen and (min-device-width: 1450px) {
    font-size: 2.9476vw;
  }
  @media only screen and (min-device-width: 1970px) {
    font-size: 2.1476vw;
  }
}
.answer-image {
  width: 80%;
  margin: 0 auto;
  display: flex;
  object-fit: contain;
  
}
.answer-image img{
  width: 100%;
  display: flex;
  object-fit: contain;
  
}
.result-form-left {
  width: 70%;
  padding-right: 50px;
}

.result-form-right {
  width: 30%;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  -webkit-touch-callout: none; 
    -webkit-user-select: none; 
     -khtml-user-select: none; 
       -moz-user-select: none; 
        -ms-user-select: none; 
            user-select: none;
}
.result-form {
  display: flex;
}
.form__title {
  font-size: 1.875vw;
  font-weight: bold;  
  @media only screen and (max-device-width: 768px) {
    font-size: 6vw; 
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 3.9476vw;
  }
}
.form__description {
  font-size: 1.0416vw;
  font-weight: normal;
  margin-top: 32px;
  margin-bottom: 40px;
  display: flex;
  @media only screen and (max-device-width: 768px) {
    font-size: 4vw; 
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.3476vw; 
  }
}
.form__description b {
  display: contents;
}
.form-title-color {
  color: #00a0e2;
}
.flow-answer__image {
  display: flex;
  margin: 0 auto;
  width: 100%;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;
}
.flow-answer__image img{
  max-width: 100%;
}
.finish-info-image {
  width: 21%;
  margin-left: auto;
  margin-right: auto;
  margin: 80px auto;
}
.finish-info-image img {
  width: 100%;
}
.finish-quantum-image {
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  margin: 80px auto;
}
.finish-quantum-image img {
  width: 100%;
}
.flow-answer__content {
  margin-left: 20px;  
  width: 100%;
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 3.3476vw; 
  }
  @media only screen and (min-device-width: 1025px) and (max-device-width: 1450px) { 
    font-size: 1.2476vw; 
  }
}

.answer-3-image {
  width: 60%;
  display: flex;
  object-fit: contain;
}
.answer-3-image img {
  width: 100%;
  display: flex;
  object-fit: contain;
}
.flow-answer__option-item {
  font-size: 1vw;
  letter-spacing: 0.2px;
  font-weight: 500;
  display: flex;
  margin-bottom: 20px;
  @media only screen and (max-device-width: 768px) {
    font-size: 3.78vw;
    
  }
}
.flow-answer__right-icon {
  width: 18px;
  align-items: flex-start;
  
  @media only screen and (max-device-width: 768px) {
    transform: translateY(10px);
    width: 30px;
    margin-right: 0;
    display: flex;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    width: 25px;
    transform: translateY(10px);
  }
}
.flow-answer__right-icon img {
  width: 100%;
}
.option-active {
  background-color: #beecff !important;
}
.answer-big-title {
  font-size: 1.6vw !important;
  @media only screen and (max-device-width: 768px) {
    font-size: 6vw !important;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    font-size: 5vw !important;
   }
   @media only screen and (max-device-width: 1024px) {
    font-size: 4vw;
  }
}
.answer-big-title i{
  display: contents;
  color: #009fe3;
}

.flow-question__option label{
  margin-left: 10px;
  width: 100%;
  
  font-weight: bold;
  @media only screen and (max-device-width: 768px) {
    font-size: 3.18125vw;
    margin-left: 25px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.3476vw;
  }
}
.flow-question__option {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  background-color: #d9d9d9;
  padding: 0px 15px;
  height: 28px;
  @media only screen and (max-device-width: 768px) {
    height: 45px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    height: 45px;
  }
}
input[type=radio] {
  @media only screen and (max-device-width: 768px) {
    transform: scale(1.5) !important;
    margin: 0 !important;
  }
}

.flow-question-item {
  padding: 0 80px;
  margin-bottom: 50px;
  @media only screen and (max-device-width: 768px) {
    font-size: 3.78vw;
    font-weight: bold;
    margin-top: 50px;
    padding: 0
  }
}
.flow-answer__title {
  @media only screen and (max-device-width: 768px) {
    margin-bottom: 40px;
    display: flex;
  }
}
.flow-question__title {
  font-size: 1vw;
  font-weight: bold;
  margin-top: 50px;
  margin-bottom: 15px;
  line-height: 1.03;
  display: flex;
  font-size: 1vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 3.78vw;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 3.3476vw;
  }
  @media only screen and (min-device-width: 1025px) and (max-device-width: 1450px) { 
    font-size: 1.2476vw;
  }
}
.flow-question__image {
  @media only screen and (max-device-width: 768px) {
    width: 100%;
    margin: 18px 0 9px 0;
  }
}
.flow-question__image img {
  width: 100%;
}
.flow-question-container {
  margin-bottom: 70px;
  @media only screen and (max-device-width: 768px) {
    padding: 0 12%;
    width: 100%; 
    margin-bottom: 400px;
  }
  @media only screen and (min-device-width: 769px) and (max-device-width: 1024px) { 
    margin-bottom: 130px;
  }
  @media only screen and (min-device-width: 1025px) and (max-device-width: 1450px) { 
    margin-bottom: 130px;
  }
}
.answers-container {
  @media only screen and (max-device-width: 768px) {
    margin-bottom: 400px;
  }
  @media only screen and (min-device-width: 769px) and (max-device-width: 1024px) { 
    margin-bottom: 130px;
  }
  @media only screen and (min-device-width: 1025px) and (max-device-width: 1450px) { 
    margin-bottom: 130px;
  }
}
.flow-status__title {
  background-color: #00a0e2;
  font-weight: bold;
    color: white;
    display: block;
    padding: 6px 0 6px 77px;
    width: 41%;
    font-size: 1.5vw;
    margin-top: 50px;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.4062vw;
    width: 40%;
    padding: 11px 0 11px 115px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 3.9476vw;
  }
}
/*.flow-title__icon {
  margin-right: 10px;
  width: 7% !important;
  display: block !important;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.4062vw;
    font-weight: bold;
    width: 100px !important;
    margin-right: 20px;
  }
}
.flow-title__icon img {
  width: 100% !important;
}*/
.flow-title {
  display: flex;
  padding: 0 25px;
  font-size: 1.5vw;
  font-weight: bold;
  line-height: 1;
  @media only screen and (max-device-width: 768px) {
    font-size: 5.4062vw;
    padding: 0 72px 0 40px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 3.9476vw;
  }
}
.flow-title span{
  width: 100%;
}
.flow-container {
  background-color: white;
  height: 100%;
  color: black;
  flex-direction: column;
  display: flex;
  overflow-y: scroll;
  width: 714px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 50px;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
  }
}
.flow-transition-top {
  position: absolute;
  top: 0;
  height: 50%;
  background-color: white;
  overflow: hidden;
  width: 100%;
}
.flow-transition-bottom {
  position: absolute;
  top: 50%;
  height: 50%;
  width: 100%;
  overflow: hidden;
  background-color: #49A5DF;
  @media only screen and (max-device-width: 768px) {
    height: 50%;
  }
}
.flow-transition-bottom__background {
  width: 115%;
  
  transform: translateY(5%);
  margin-left: -20%;
  background-repeat: no-repeat;
  @media only screen and (max-device-width: 768px) {
    transform: translateX(0);
    width: 115%;
  }
  @media only screen and (max-device-width: 450px) {
    width: 140%;
    transform: translateX(-5%);
  }
}
.flow-transition-bottom__background img{
  width: 100%;
}
.flow-transition-top__container {
  display: flex;
  
}
.flow-transition-top__left-image {
  width: 50%;
  height: 100%;
  transform: translateY(16%);
  @media only screen and (max-device-width: 768px) {
    transform: translateY(20%);
    width: 35%;
  }
  @media only screen and (max-device-width: 450px) {
    width: 47%;
  }
}
.flow-transition-top__left-image img {
  width: 100%;
}

.flow-transition-top__right-image {
  width: 47%;
  display: flex;
  align-items: center;
  @media only screen and (max-device-width: 768px) {
    width: 12vw;
  }
}
.flow-transition-top__right-image img {
  width: 100%;
}
.flow-transition-bottom__content {
  font-size: 1.675vw;
  text-align: right;
  width: 100%;
  position: absolute;
  top: 6%;
  right: 4%;
  font-weight: bold;
  @media only screen and (max-device-width: 768px) {
    font-size: 5vw;
  }
  @media only screen and (max-device-width: 1024px) {
    font-size: 4vw;
  }
  @media only screen and (max-device-width: 450px) {
    font-size: 6vw;
  }
}
.flow-transition-bottom__button {
  
  margin-left: 14px;
  width: 0.85vw;
  @media only screen and (max-device-width: 768px) {
    width: 2.85vw;
    display: flex;
  }
  @media only screen and (max-device-width: 1024px) {
    width: 2.5vw;
    display: flex;
  }
}
.flow-transition-bottom__text {
  font-size: 1.875vw;
  font-weight: bold;
  @media only screen and (max-device-width: 768px) {
    font-size: 6vw;
  }
  @media only screen and (max-device-width: 1024px) {
    font-size: 5vw;
  }
}
.flow-transition-bottom__button img {
  width: 100%;
}
#number-input {
  position: relative;
}
#number-input span {
  top: 24%;
  left: 6%;
  position: absolute;
    font-size: 0.9vw;
    top: 50%;
    left: 0;
   margin-top: -1;
    transform: translateY(-50%);
    padding: 17px 0px 18px 30px;
    z-index: 1;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.2vw;
    top: 50%;
    padding: 17px 0px 18px 42px;
  }
}
.flow-transition-top-complete {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: black;
  justify-content: center;
  width: 48%;
  
}

.flow-transition-top-complete__text {
  display: flex;
  align-items: center;
  font-size: 3.8802vw;
  font-weight: bold;
  @media only screen and (max-device-width: 768px) {
    font-size: 12vw;
  }
  @media only screen and (max-device-width: 1024px) {
    font-size: 10vw;
  }
}
.flow-transition-top__right-image {
  width: 3.6vw;
  @media only screen and (max-device-width: 768px) {
    width: 12vw;
  }
  @media only screen and (max-device-width: 1024px) {
    width: 10vw;
  }
}
.flow-transition-top__right-image img {
  width: 100%;
}

.flow-transition-top-complete__bottom-text {
  font-size: 1.875vw;
  font-weight: bold;
  transform: translateY(-35%);
  @media only screen and (max-device-width: 768px) {
    font-size: 6vw;
    transform: translateY(-10%);
  }
  @media only screen and (max-device-width: 1024px) {
    font-size: 5vw;
  }
}
.flow-transition-bottom-container {
  display: flex;
  align-items: center;
  position: absolute;
  right: 4%;
  bottom: 10%;
}
#number-input .result-item-form__input {
  @media only screen and (max-device-width: 768px) {
    padding: 30px 70px;
    font-size: 4.2vw;
  }
}

.flow-start__description-text span{
  color: #009EE2;
}
.flow-start__description-text b {
  font-weight: 600;
}
.flow-start__description-new {
  display: flex;
  font-size: 1.015vw;
  margin-top: 0;
  margin-bottom: 1.704vw;
  position: relative;
  @media only screen and (max-device-width: 768px) {
    font-size: 2rem;
    margin-top: 3%;
    text-align: center;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
  @media screen and (min-width: 2001px) {
      align-items: center;
  }
}
.flow-start__description-icon {
  width: 10%;
  left: -13%;
  position: absolute;
  @media only screen and (max-device-width: 768px) {
    left: 0;
    display: flex;
    margin: 10px 15px 10px 0;
  }
}
.flow-start__description-icon img {
  width: 100%;  
}

.horizontal {
  width: 100%;
  height: auto;
}
.result-messages {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vue-form-wizard.md li.active .wizard-icon-circle.tab_shape.checked .wizard-icon {
    background: #F3F2EE;
    display: block!important;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    text-indent: -50000px;
    height: 100%;
    z-index: 99;
}
.selectbox::before {
  width: 0;
  z-index: 1;
  content: '';
  height: 0;
  right: 30px;
  transform: translateY(-50%);
  top: 50%;
  position: absolute;
  border-style: solid;
  border-width: 12px 6px 0 6px;
  border-color: #009EE2 transparent transparent transparent;
@media only screen and (max-device-width: 768px) {
    right: 10%;
    top: 50%;
    border-width: 18px 12px 0 12px;
  }
}

.wizard-icon-circle span {
  position: absolute;
  z-index: 99;
  width: 0;
  height: 100%;
  background-color: #00a0e2;
  left: 0;
  top: 0;
}
.flow-title__close {
  margin-left: auto;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 16px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  z-index: 10;
  object-fit: contain;
  cursor: pointer;
  @media only screen and (max-device-width: 768px) {
    width: 40px;
    height: 40px;
    top: 0;
  }
}
.flow-title__close img {
  width: 100%;
  border-radius: 50%;
  background-image: white;
  object-fit: contain;
  display: flex;
}
.navbar-timeline {
  position: absolute;
  z-index: 10;
  width: 50%;//~~
  height: 100%;
  left: 0;
  top:0;
  background-color: red;  //hhis.activeTab'den alınacak li elementlerinden.
}

#custom-seekbar
{  
  cursor: pointer;
  height: 10px;
  margin-bottom: 10px;
  outline: thin solid orange;
  overflow: hidden;
  position: relative;
  width: 400px;
}
#custom-seekbar span
{
  background-color: orange;
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  width: 0px;
}
.background__loading {
  height: 100%;
  width: 20%;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}
.vue-form-wizard .wizard-nav-pills li:first-child,
.vue-form-wizard .wizard-nav-pills li:last-child {
  display: none;
}
.flow-start__left {
  width: 41%;
  margin: 44px 0;
  @media only screen and (max-device-width: 768px) {
    width: 61%;
    display: flex;
    flex-direction: column;
    color: black;
    align-items: center;
    margin: 0;
    transform: translateY(-6%);
  }
  @media only screen and (max-device-width: 767px) {
    width: 70%;
    display: flex;
    flex-direction: column;
    color: black;
    align-items: center;
    margin: 0;
    transform: translateY(-10%);
  }
}

.mobile-start-button {
  color: black;
  display: none;
  
  @media only screen and (max-device-width: 768px) {
    font-size: 4.317vw;
    border-radius: 90px;
    /*margin-top: 5%;*/
    border: 3px solid #009ffd;
    padding: 3.7%;
    width: 50%;
    cursor: pointer;
    display: block;
    align-items: center;
    text-align: center;
    background-color: #00a0e2;
    color: white;
  }
}


.flow-start__left img {
  object-fit: contain;
  width: 100%;
  display: flex;
}
.flow-start__right {
  display: flex;
  width: 59%;
  flex-direction: column;
  color: black;
  margin-left: 30px;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    margin: 0 auto 20px auto;
    transform: translateY(8%);
  }
  @media only screen and (max-device-width: 767px) {
    transform: translateY(0%);
  }
  @media screen and (min-device-width: 2001px) {
    padding: 5% 0;
  }
}
.flow-start__right .flow-start__title {
  font-size: 2.240vw;
  font-weight: bold;
  color: #00a0e2;
  @media only screen and (max-device-width: 768px) {
    font-size: 3.4rem;
    text-align: center;
  }
}
.flow-start__right .flow-start__description {
  font-size: 1.015vw;
  color: black;
  margin-bottom: 2.604vw;
  font-weight: 600;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 2rem;
    text-align: center;
    margin: 36px 0 0 0;
  }
}
.flow-start__right .flow-start__button span {
  font-size: 1.1rem;
  border-radius: 30px;
  border: 1px solid #00a0e2;
  padding: 2.7% 9.3%;
  transition: all 0.5s ease;
  @media only screen and (max-device-width: 768px) {
    font-size: 40px;
    display: block;
  }
}

.flow-start__right .flow-start__button {
  cursor: pointer;
  @media only screen and (max-device-width: 768px) {
    display: none;
  }
}

.flow-start__right .flow-start__button span {
  color: black;
  font-weight: 600;
}
.flow-start__right .flow-start__button span:hover {
  background-color: #00a0e2;
  cursor: pointer;
  color: white;
}

.flow-start__left img {
  width: 100%;
}
.flow-start-container {
  background-color: white;
  display: flex;
  padding-right: 3.333vw;
  width: 56.56%;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    padding: 0;
    height: 100vh;
    margin-top: 0;
    justify-content: center;
    align-items: center;
  }
}
.no-vote-rate {
  color: #ff0000;
  font-size: 25px;
  @media only screen and (max-device-width: 768px) {
    font-size: 5vw !important;
  }
}
.yes-vote-rate {
  color: #00a0e2;
  font-size: 25px;
  @media only screen and (max-device-width: 768px) {
    font-size: 5vw !important;
  }
}
.selected-option {
  background-color: #d9f4ff;
}
.unmute-container {
  position: absolute;
  bottom: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 99;
  justify-content: center;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.unmute__text {
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  border-radius: 20px;
  bottom: 20px;
  position: absolute;

  cursor: pointer;
}
.vue-form-wizard.md .wizard-icon-circle.tab_shape.checked {
  background-color: rgb(0, 160, 226);
}
.result-item-form__success {
  justify-content: center;
  display: flex;
  text-align: center;
  color: #00a0e2;
  display: none;
  font-size: 1vw;
  margin-bottom: 30px;
  font-weight: bold;
}
.result-item-form__error {
  justify-content: center;
  display: flex;
  text-align: center;
  color: red;
  display: none;
  font-size: 1vw;
  font-weight: bold;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.2vw;
    margin-top: 50px;
    margin-bottom: 30%;
  }
}
.result-item-form {
  position: relative;
}
.result-item-form__loading {
  width: 50px;
  display: none;
  margin-left: auto;
  margin-right: auto;
}
.result-item-form__loading img {
  width: 100%;
}
.step-by-step-modal {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 20;
  display: flex;
  position: absolute;
}
@media only screen and (max-device-width: 768px) {
  body .wp-main-content {
    font-size: 4vw;
  }
}
.valid-input {
  top: -15px !important;
  padding: 5px 10px !important;
  left: 0 !important;
  transform: translateX(30px) !important;
  font-size: 0.817vw !important;
  width: auto !important;
  background-color: white !important;
  @media only screen and (max-device-width: 768px) {
    font-size: 2.817vw !important;
    top: -27px !important;
  }
}
.result-right .result-item p {
  display: block;
  font-size: 0.9rem;
  @media only screen and (max-device-width: 768px) {
    font-size: 2.317vw;
    margin-bottom: 8%;
  }
}
.close-button {
  cursor: pointer;
  right: 20px;
}
.top-gradient {
  background: linear-gradient(#000000, transparent);
  height: 105px;
  width: 100%;
  z-index: 9;
  position: absolute;
  @media only screen and (max-device-width: 768px) {
    height: 15%;
  }
}
#kvkk {
  
  display: flex;
  @media only screen and (max-device-width: 768px) {
    height: 20px;
    width: 20px;
    margin-left: 12px;
  }
}

.result-item__check-item input {
  margin: 0 15px 0 0;
  display: flex;
  @media only screen and (max-device-width: 768px) {
    height: 30px;
    width: 30px;
    margin-left: 12px;
  }
}
.result-item__check-item {
  display: flex;
  align-items: center;
  margin-left: -2px;
  margin-bottom: 20px;
  @media only screen and (max-device-width: 768px) {
    margin-bottom: 4%;
  }
}
.mobile-result-left {
  display: none;
  @media only screen and (max-device-width: 768px) {
    display: block;
    border-bottom: 2px solid #00a0e2 !important;
    margin-bottom: 110px;
    padding-bottom: 110px;
  }
}
button.owl-dot {
  border: 1px solid gray !important;
  margin: 0 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.owl-theme .owl-dots .owl-dot span {
  width: 25px;
  height: 25px;
  margin: 0;
  background: white !important;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background-color: #00a0e2 !important;
  width: 20px;
  height: 20px;
  margin: 3px 4px;
}
.result-item-form-container {
  margin-bottom: 20px;
}
.wizard-tab-container {
  height: 100%;
  display: flex;
  align-items: center;
  
}
.result-item-form__input-button {
  background-color: #00a0e2;
  border-radius: 22.3px;
  padding: 16px 0 21px;
  width: 100%;
  font-weight: bold;
  color: white;
  font-family: Quicksand;
  border: none;
  cursor: pointer;
  -webkit-appearance: none;
  font-size: 1.1718vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 44px;
    border-radius: 35px;
    font-weight: 500;
    margin: 20% 0;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.5476vw;
  }
}
.result-item__question {
  margin-bottom: 25px;
}
.result-item__question-text {
  font-weight: bold;
  font-size: 0.9vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 3.317vw;
    width: 100%;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.0476vw;
  }
}
.result-item__radiobuttons {
  margin-top: 10px;
  @media only screen and (max-device-width: 768px) {
    margin-top: 7.5%;
  }
}

.result-item__radio-item {
font-size: 1.1rem;
display: flex;
align-items: center;
margin-bottom: 10px;
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.0476vw;
}
}

.result-item__radio-item.kvkk-radio label{
  display: flex;
  font-weight: bold;
}
.result-item__radio-item label {
  font-weight: 500;
}

.result-item__radio-item label {
  @media only screen and (max-device-width: 768px) {
    font-size: 3.317vw;
  }
}
.result-item__radio-item input[type="radio"] {
  width: 15px;
  height: 15px;
  margin: 0 6px;
  transform: translateY(1px);
  margin-right: 15px !important;
  
  @media only screen and (max-device-width: 768px) {
    width: 20px;
    height: 20px;
  }
}
.result-item__radio-item input[type="checkbox"] {
  width: 15px;
  height: 15px;
  margin-right: 10px;

  @media only screen and (max-device-width: 768px) {
    width: 30px;
    height: 30px;
  }
}
/*.result-item-form__input::placeholder {
      color: black;
      font-weight: 500;
      text-align: center;
      font-size: 18.5;
    }*/
.result-item-form__input {
  
    width: 100%;
    border-radius: 26.5px;
    border: solid 2px #00a0e2;
    /* padding: 17px 10px 18px 10px; */
    /* margin-bottom: 25px; */
    outline: 0;
    height: 60px;
    font-size: 0.9vw;
    position: relative;
    padding-left: 40px;
    text-align: left !important;
  @media only screen and (max-device-width: 768px) {
    padding: 30px 40px;
    border-radius: 35px;
    font-size: 4.2vw;
    height: 110px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.3476vw;
  }
}

.item-form-wrapper {
  position: relative;
  display: flex;
  margin-bottom: 25px;
  @media only screen and (max-device-width: 768px) {
    margin-bottom: 55px;
  }
}

.item-form-wrapper select {
  text-align: -moz-center;
  text-align: -webkit-center;
  text-align: center;
  
  
  -webkit-appearance: none;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.2vw;
    background-color: white;
  }
}

.item-form-wrapper select option {
  
  @media only screen and (max-device-width: 768px) {
    font-size: 1.5vw;
  }
}
.result-item-form__placeholder {
  color: black;
  font-weight: 500;
  font-size: 0.9vw;
  width: 100%;
  transition: 0.2s ease all;
  -webkit-transition: 0.4 ease all;
  left: 0;
  
  width: fit-content;
  position: absolute;
  pointer-events: none;
  background-color: transparent;
  white-space: nowrap;
  padding-left: 40px;
  top: 50%;
  transform: translateY(-50%);
  @media only screen and (max-device-width: 768px) {
    font-size: 4.0vw;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) { 
    font-size: 2.3476vw; 
  }
}


input:focus ~.result-item-form__placeholder{
  top: -15px;
  padding: 5px 10px;
  left: 0;
  transform: translateX(30px);
  font-size: 14px;
  width: auto;
  background-color: white;
  width: auto;
  white-space: nowrap;
  @media only screen and (max-device-width: 768px) {
    font-size: 2.9vw;
    left: 5px;
    top: -25px;
  }
}
.result-hr {
  background-color: #dcdcdc;
  width: 3px;
  height: auto;
  //margin-left: -17px;
}
.result-active-tab .result-item__icon img {
  transform: rotate(90deg) !important;
  @media only screen and (max-device-width: 768px) {
    transform: none;
  }
}

.result-item__content {
  transition: height 1s ease;
  font-size: 0.9rem;
}

.result-item.result-active-tab .result-item__content p {
  display: block;
}

.result-active-tab {
  transition: all 1s ease;
}
.result-item__video {
  background-color: black;
  width: 100%;
  height: 300px;
  margin-left: -16px;
}
.result-item__content p {
  margin-left: 32px;
  padding-right: 90px;
  @media only screen and (max-device-width: 768px) {
    font-size: 25px;
  }
}
.result-item__title {
  display: flex;
  font-weight: bold;
  font-size: 0.9vw;
  cursor: pointer;
  @media only screen and (max-device-width: 768px) {
  }
}
.result-item__title span {
  width: 100%;
  @media only screen and (max-device-width: 768px) {
    font-size: 50px;
  }
}
.result-item__icon {
  width: 17px;
  margin-right: 15px;
  @media only screen and (max-device-width: 768px) {
    width: 30px;
  }
}
.result-item__icon img {
  width: 100%;
  transition: all 1s ease;
}
.result-item {
  color: black;
  margin-bottom: 33px;
  transition: all 0.3s linear;
}
.result-item .result-item__icon img {
  transform: rotate(0deg);
  transition: all 1s ease;
}
.result-item p {
  display: none;
  @media only screen and (max-device-width: 768px) {
    font-size: 37px;
  }
}
.result-left {
  width: 60%;
  padding-right: 20px;
  overflow-y: auto;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
    padding: 0 87px;
    display: none;
  }
}
.result-right {
  width: 40%;
  padding: 0 40px 0 60px;
  overflow-y: auto;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
    overflow-y: initial;
  }
}
.result-container {
  width: 85%;
  display: flex;
  height: 96vh;
  background-color: white;
  padding: 30px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  @media only screen and (max-device-width: 768px) {
    flex-direction: column;
    height: 100vh;
    width: 100%;
    padding: 90px 100px;
    overflow: scroll;
  }
}
.watch-again-container {
  background-image: url('../../src/assets/img/icons/tekrar-izle.svg');
  background-repeat: no-repeat;
  background-size: 26px;
  background-position: 10% center;
  padding-right: 10px;
  width: 37%;
  display: flex;
  position: absolute;
  left: 0px;
  cursor: pointer;
  background-color: #00a0e2;
  height: 35px;
  align-items: center;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  top: 100px;
  z-index: 999999;
  @media only screen and (max-device-width: 768px) {
    width: 39%;
    margin-top: 16%;
    height: 70px;
    padding-right: 5%;
    background-size: 46px;
  }
}
.watch-again__text {
  font-size: 1.202vw;
  width: 100%;
  text-align: right;
  font-weight: 500;
  left: 29%;
  @media only screen and (max-device-width: 768px) {
    font-size: 4.7vw;
    left: 26%;
  }
}
.watch-again__icon {
  width: 50px;
  height: 40px;
  margin-right: 3px;
  position: absolute;
  transform: scale(0.9);
  @media only screen and (max-device-width: 768px) {
    font-size: 50px;
    transform: scale(1.6);
  }
}
.watch-again__icon img {
  width: 100%;
  margin-top: 2px;
}
.watch-again-container img {
  width: 100%;
}
.watch-again__icon img {
  width: 100%;
}
.vue-form-wizard .wizard-icon-circle.tab_shape {
  min-width: auto !important;
}

.result-item__content a,
.vue-form-wizard .result-item__check-item a {
  color: #00a0e2;
}
.vote-item__icon {
  width: 31%;
  display: flex;
  @media only screen and (max-device-width: 768px) {
    width: 6vw;
    
  }
}
.vote-item__icon img {
  width: 100%;
  display: flex;
  object-fit: contain;
}
.vote-item__hr {
  background-color: #4a4a4a;
  width: 1px;
  height: 81%;
  @media only screen and (max-device-width: 768px) {
    display: flex;
    height: 130px;
  }
}
.vote-container {
  width: 48%;
  border-radius: 20px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  //padding: 10px 0;
  margin-top: 20px;
  z-index: 99;
  overflow: hidden;
  flex: 0 0 auto;
  
  //display: none;
  @media only screen and (max-device-width: 768px) {
    
  }
}

.vote-item {
  color: black;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  padding: 6% 0;
  font-weight: bold;
  margin-top: -1px;
  height: 5.5vw;
  cursor: pointer;
  @media only screen and (max-device-width: 768px) {
    height: 18vw;
  }
}

.vote-item span {
    font-size: 1.3vw;
    margin-top: 5px;
    @media only screen and (max-device-width: 768px) {
    font-size: 4vw;
    //margin-top: 10px;
  }
}
.flow-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 5vh;
  left: 0;
  position: absolute;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-device-width: 768px) {
    bottom: 15vh;
  }
}
.flow-content__name {
  z-index: 9;
  background-color: #00a0e2;
  padding: 2px 8px;
  border-radius: 17px;
  color: white;
  margin-bottom: 1px;
  font-weight: 500;
  font-size: 1.6rem;
}
.flow-content__description {
  width: auto;
  text-align: center;
  color: black;
  background-color: white;
  border-radius: 17px;
  margin: 1px;
  padding: 2px 15px;
  font-weight: bold;
  font-size: 1.3vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 4vw;
  }
}
.flow-title-container {
  display: flex;
  z-index: 9999;
  width: 100%;
  top: 40px;
  align-items: center;
  position: absolute;
  padding: 0 20px;
  height: 50px;
  @media only screen and (max-device-width: 768px) {
    top: 5.5%;
  }
}
.flow-title__icon {
  z-index: 9;
  width: 40px;
  height: 40px;
  display: flex;
  margin-right: 17px;
  transform: translateY(-5px);
  @media only screen and (max-device-width: 768px) {
    width: 70px;
    height: 70px;
    transform: translateY(-10px);
  }
}
.flow-title__icon img {
  width: 100%;
  @media only screen and (max-device-width: 768px) {
    
  }
}
.flow-title__text {
  z-index: 9;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 0.938vw;
  font-weight: bold;
  width: 100%;
  padding-right: 50px;
  @media only screen and (max-device-width: 768px) {
    font-size: 2.25rem;
  }
}
.vue-form-wizard {
  z-index: 10;
  padding-bottom: 0;
  /*overflow: hidden;*/
  @media only screen and (max-device-width: 768px) {
  }
}
.vue-form-wizard .wizard-tab-content {
  padding: 0 !important;
  height: 100vh;
  @media only screen and (max-device-width: 768px) {
    padding: 0 !important;
  }
}
.wp-main-content {
  /*background-color: gray !important;*/

  width: 100%;
}
.wizard-header {
  display: none;
}
.vue-form-wizard .wizard-nav-pills > li > a {
  top: 0 !important;
}
.vue-form-wizard .wizard-nav {
  padding: 0 15px !important;
}
.vue-form-wizard .wizard-nav-pills {
  position: absolute !important;
  z-index: 999;
  top: 3%;
  width: 100%;
  padding: 0 15px;
  @media only screen and (max-device-width: 768px) {
    top: 45px;
  }
}
.wizard-progress-with-circle {
  display: none;
}
.wizard-icon {
  display: none !important;
}
.ss-close {
  z-index: 99;
  background-color: white;
}
.vue-form-wizard.md .wizard-icon-circle.tab_shape {
  height: 5px !important;
}
.vue-form-wizard .wizard-nav-pills a,
.vue-form-wizard .wizard-nav-pills li {
  margin: 0 2px;
}
.wizard-footer-right {
  width: 50%;
  display: flex;
  height: 100%;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.wizard-footer-right button {
  width: 100%;
  z-index: 9;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.wizard-footer-left {
  width: 50%;
  height: 100%;
  display: flex;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.wizard-footer-left button {
  width: 100%;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.vue-form-wizard.md {
  position: absolute;
  /*min-width: 540px;*/
  width: auto;
  //top: 70px !important;
  /*padding: 21px 16px;*/
  /*background-color: white;*/
  @media only screen and (max-device-width: 768px) {
    top: -1px;
    width: 100%;
  }
}
.background-image {
  position: relative;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  @media only screen and (max-device-width: 768px) {
    height: 100%;
    width: 100%;
    background: -moz-linear-gradient(top, #EFF2F7 48%, #E7EBF0 55%, #DFE3E8 68%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #EFF2F7 48%,#E7EBF0 55%,#DFE3E8 68%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #EFF2F7 48%,#E7EBF0 55%,#DFE3E8 68%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }
}

.background-image img {
  height: 100%;
}
.background-image video {
  height: 100vh;
  z-index: 0;
  top: 0;
  left: 0;
  transform: none;
  @media only screen 
    and (device-width : 375px) 
    and (device-height : 812px) 
    and (-webkit-device-pixel-ratio : 3) { 
      width: 100%;
    }
}
#step-by-step .wp-main-content {
  background-color: transparent;
  height: 100%;
  overflow-y: visible;
  align-items: center;
  max-height: none;
  display: flex;
  justify-content: center;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
  }
}
#close-button.ss-close img {
  width: 100%;
  object-fit: contain;
}
#step-by-step .ss-close {
  width: 20px;
  height: 20px;
  display: flex;
  margin-bottom: 0;
  top: 5.5%;
  position: absolute;
  right: 4%;
  border-radius: 50%;
  cursor: pointer;
  z-index: 99999;
  @media only screen and (max-device-width: 768px) {
    width: 45px;
    height: 45px;
    margin-left: auto;
  }
}
#step-by-step .last-tab-close img {
  object-fit: contain;
  width: 100%;
}

.first-tab-close {
  margin-bottom: 0;
  display: flex;
  right: -30px;
  top: 25px;
  margin-right: 0;
  position: absolute;
  z-index: 999999;
  cursor: pointer;
  object-fit: contain;
  bottom: auto;
  @media only screen and (max-device-width: 768px) {
    right: 2%;
    width: 50px;
    height: 50px;
    top: 90px;
    display: flex;
  }
}
.last-tab-close {
  margin-bottom: 0;
  display: flex;
  right: -50px;
  top: 10px;
  position: absolute;
  background-color: white;
  border-radius: 50%;
  z-index: 999999;
  cursor: pointer;
  object-fit: contain;
  bottom: auto;
  @media only screen and (max-device-width: 768px) {
    right: 30px;
    width: 50px;
    height: 50px;
    top: 6%;
  }
}
#step-by-step .ss-close img {
  width: 100%;
  @media only screen and (max-device-width: 768px) {
    width: 100%;
  }
}

.vue-form-wizard .wizard-card-footer {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  padding: 0 !important;
  display: block;
}

.wizard-navigation {
  height: 100%;
  //background-color: white;
  position: relative;
}
#step-by-step {
  display: flex;
  position: fixed;
  //font-size: 2vw;
}


.vote-item .fs--04vw{
  font-size: 0.4vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 1.6vw;;
  }
}
.vote-item .fs--07vw {
  font-size: 0.7vw;
  @media only screen and (max-device-width: 768px) {
    font-size: 2.7vw;;
  }
}


</style>
